import { useState, useEffect } from 'react';
import api from '../../../api/client';

const EMPTY_FORM = { title: '', valueCents: '', startDate: '', endDate: '' };

export default function SowPage() {
  const [sows,    setSows]    = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);
  const [addOpen, setAddOpen] = useState(false);
  const [form,    setForm]    = useState(EMPTY_FORM);
  const [saving,  setSaving]  = useState(false);

  async function load() {
    setLoading(true);
    try {
      const { data } = await api.get('/vms/sow');
      setSows(data.data?.items || []);
    } catch (e) {
      setError(e.response?.data?.message || e.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { load(); }, []);

  function patch(key, val) {
    setForm((f) => ({ ...f, [key]: val }));
  }

  async function handleAdd(e) {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      await api.post('/vms/sow', {
        title:      form.title,
        valueCents: Number(form.valueCents),
        startDate:  form.startDate,
        endDate:    form.endDate,
      });
      setForm(EMPTY_FORM);
      setAddOpen(false);
      await load();
    } catch (e) {
      setError(e.response?.data?.message || e.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div data-testid="vms-sow-page" data-loading={loading ? 'true' : 'false'}>
      <h2>Statements of Work</h2>

      {error && <p style={{ color: 'red' }}>{error}</p>}

      <div style={{ marginBottom: '1rem' }}>
        <button data-testid="vms-sow-add" onClick={() => setAddOpen(true)}>
          Add SOW
        </button>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table style={{ width: '100%' }}>
          <thead>
            <tr>
              <th>Title</th>
              <th>Value</th>
              <th>Start</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {sows.map((s) => (
              <tr key={s.id} data-testid={`vms-sow-row-${s.id}`}>
                <td>{s.title}</td>
                <td>{s.value_cents != null ? `$${(s.value_cents / 100).toFixed(2)}` : '—'}</td>
                <td>{s.start_date?.slice(0, 10)}</td>
                <td>{s.status}</td>
              </tr>
            ))}
            {!sows.length && <tr><td colSpan={4}>No statements of work yet.</td></tr>}
          </tbody>
        </table>
      )}

      {addOpen && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 8, padding: '1.5rem', minWidth: 360 }}>
            <h3>Add Statement of Work</h3>
            <form onSubmit={handleAdd}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <input
                  placeholder="Title"
                  value={form.title}
                  onChange={(e) => patch('title', e.target.value)}
                  required
                />
                <input
                  placeholder="Value (cents)"
                  type="number"
                  min={0}
                  value={form.valueCents}
                  onChange={(e) => patch('valueCents', e.target.value)}
                  required
                />
                <label>
                  Start Date
                  <input
                    type="date"
                    value={form.startDate}
                    onChange={(e) => patch('startDate', e.target.value)}
                    required
                  />
                </label>
                <label>
                  End Date
                  <input
                    type="date"
                    value={form.endDate}
                    onChange={(e) => patch('endDate', e.target.value)}
                  />
                </label>
              </div>
              {error && <p style={{ color: 'red', marginTop: '0.5rem' }}>{error}</p>}
              <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem' }}>
                <button type="submit" data-testid="vms-sow-form-submit" disabled={saving}>
                  {saving ? 'Saving...' : 'Save'}
                </button>
                <button type="button" onClick={() => { setAddOpen(false); setError(null); }}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
